const isTestParam = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const testOnly = urlParams.get('test_only');

  return testOnly?.toLowerCase() === 'true';
};

export default isTestParam;
